import i18n from "src/translations";

/**
 * formatter for admission status cell
 * @param {string} cell the admission status
 */
export function admissionStatusFormatter(cell) {
  return cell ? i18n.t(`data.admissionStatus.${cell}`) : "";
}
